import React from 'react';
import {IconButton} from '../elements';
import {MoreLessToggle} from "./MoreLessToggleInner";


type MoreLessToggleIconProps = {
    isOpen: boolean;
    doubleArrow?: boolean;
    onClick?: () => void;
    color?: string;
};

export function MoreLessToggleIcon(props: MoreLessToggleIconProps) {

    return (
        <IconButton style={{color: props.color}} className={`"p-0 w-[29px]"`} onClick={props.onClick}>
            <MoreLessToggle isOpen={props.isOpen} doubleArrow={props.doubleArrow}/>
        </IconButton>
    );
}
